import React from "react";
import { MakeLabelParams } from "../../types/MakeLabelParams";
import { ColorView } from "./ColorView";

export const makeColorViewLabel = (data: MakeLabelParams) => (
  <ColorView params={data} />
);
